import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useI18N } from '../../context/I18NContext';
import { Box, FormControl, InputLabel, MenuItem, Select, ListItemText, Divider, useTheme } from '@mui/material';
import { NL, BE, DE, FR, GB, ES, AF, AL, DZ, AS, VI, AD, AO, AG, AR, AM, AW, AU, AZ, BS, BH, BD, BB, BY, BZ, BJ, BM, BT, BO, BA, BW, BR, VG, BN, BG, BF, BI, KH, CA, BQ, CF, CL, CN, CO, KM, CG, CD, CR, CU, CW, CY, DK, DJ, DM, DO, EC, EG, SV, GQ, ER, EE, SZ, ET, FJ, PH, FI, GF, GA, GM, GE, GH, GI, GD, GR, GL, GP, GU, GT, GG, GW, GY, HT, HN, HU, HK, IS, IN, ID, IQ, IR, IE, IM, IL, IT, CI, JM, JP, YE, JE, JO, CV, CM, KZ, KE, KG, KI, KW, HR, LA, LS, LV, LB, LR, LY, LI, LT, LU, MG, MW, MV, MY, ML, MT, MA, MH, MQ, MR, MU, MX, FM, MD, MC, MN, ME, MZ, MM, NA, NR, NP, NZ, NI, NE, NG, NU, KP, MK, NO, UG, UA, UZ, OM, TL, AT, PK, PW, PS, PA, PG, PY, PE, PL, PT, PR, QA, RO, RU, RW, KN, LC, VC, SB, WS, SM, ST, SA, SN, RS, SC, SL, SG, SX, SI, SK, SD, SO, ZA, LK, SR, SY, TJ, TW, TZ, TH, TG, TK, TO, TT, TD, CZ, TN, TR, TM, TV, US, UY, VU, VA, VE, AE, VN, EH, ZM, ZW, KR, SS, SE, CH } from 'country-flag-icons/react/3x2';
const Flags = {
    NL: _jsx(NL, {}), BE: _jsx(BE, {}), DE: _jsx(DE, {}), FR: _jsx(FR, {}), GB: _jsx(GB, {}), ES: _jsx(ES, {}),
    AF: _jsx(AF, {}), AL: _jsx(AL, {}), DZ: _jsx(DZ, {}), AS: _jsx(AS, {}), VI: _jsx(VI, {}),
    AD: _jsx(AD, {}), AO: _jsx(AO, {}), AG: _jsx(AG, {}), AR: _jsx(AR, {}), AM: _jsx(AM, {}),
    AW: _jsx(AW, {}), AU: _jsx(AU, {}), AZ: _jsx(AZ, {}), BS: _jsx(BS, {}), BH: _jsx(BH, {}),
    BD: _jsx(BD, {}), BB: _jsx(BB, {}), BY: _jsx(BY, {}), BZ: _jsx(BZ, {}), BJ: _jsx(BJ, {}),
    BM: _jsx(BM, {}), BT: _jsx(BT, {}), BO: _jsx(BO, {}), BA: _jsx(BA, {}), BW: _jsx(BW, {}),
    BR: _jsx(BR, {}), VG: _jsx(VG, {}), BN: _jsx(BN, {}), BG: _jsx(BG, {}), GF: _jsx(GF, {}),
    BF: _jsx(BF, {}), BI: _jsx(BI, {}), KH: _jsx(KH, {}), CA: _jsx(CA, {}), BQ: _jsx(BQ, {}),
    CF: _jsx(CF, {}), CL: _jsx(CL, {}), CN: _jsx(CN, {}), CO: _jsx(CO, {}), KM: _jsx(KM, {}),
    CG: _jsx(CG, {}), CD: _jsx(CD, {}), CR: _jsx(CR, {}), CU: _jsx(CU, {}), CW: _jsx(CW, {}),
    CY: _jsx(CY, {}), DK: _jsx(DK, {}), DJ: _jsx(DJ, {}), DM: _jsx(DM, {}), DO: _jsx(DO, {}),
    EC: _jsx(EC, {}), EG: _jsx(EG, {}), SV: _jsx(SV, {}), GQ: _jsx(GQ, {}), ER: _jsx(ER, {}),
    EE: _jsx(EE, {}), SZ: _jsx(SZ, {}), ET: _jsx(ET, {}), FJ: _jsx(FJ, {}), PH: _jsx(PH, {}),
    FI: _jsx(FI, {}), GA: _jsx(GA, {}), GM: _jsx(GM, {}), GE: _jsx(GE, {}), GH: _jsx(GH, {}),
    GI: _jsx(GI, {}), GD: _jsx(GD, {}), GR: _jsx(GR, {}), GL: _jsx(GL, {}), GP: _jsx(GP, {}),
    GU: _jsx(GU, {}), GT: _jsx(GT, {}), GG: _jsx(GG, {}), GW: _jsx(GW, {}), GY: _jsx(GY, {}),
    HT: _jsx(HT, {}), HN: _jsx(HN, {}), HU: _jsx(HU, {}), HK: _jsx(HK, {}), IS: _jsx(IS, {}),
    IN: _jsx(IN, {}), ID: _jsx(ID, {}), IQ: _jsx(IQ, {}), IR: _jsx(IR, {}), IE: _jsx(IE, {}),
    IM: _jsx(IM, {}), IL: _jsx(IL, {}), IT: _jsx(IT, {}), CI: _jsx(CI, {}), JM: _jsx(JM, {}),
    JP: _jsx(JP, {}), YE: _jsx(YE, {}), JE: _jsx(JE, {}), JO: _jsx(JO, {}), CV: _jsx(CV, {}),
    CM: _jsx(CM, {}), KZ: _jsx(KZ, {}), KE: _jsx(KE, {}), KG: _jsx(KG, {}), KI: _jsx(KI, {}),
    KW: _jsx(KW, {}), HR: _jsx(HR, {}), LA: _jsx(LA, {}), LS: _jsx(LS, {}), LV: _jsx(LV, {}),
    LB: _jsx(LB, {}), LR: _jsx(LR, {}), LY: _jsx(LY, {}), LI: _jsx(LI, {}), LT: _jsx(LT, {}),
    LU: _jsx(LU, {}), MG: _jsx(MG, {}), MW: _jsx(MW, {}), MV: _jsx(MV, {}), MY: _jsx(MY, {}),
    ML: _jsx(ML, {}), MT: _jsx(MT, {}), MA: _jsx(MA, {}), MH: _jsx(MH, {}), MQ: _jsx(MQ, {}),
    MR: _jsx(MR, {}), MU: _jsx(MU, {}), MX: _jsx(MX, {}), FM: _jsx(FM, {}), MD: _jsx(MD, {}),
    MC: _jsx(MC, {}), MN: _jsx(MN, {}), ME: _jsx(ME, {}), MZ: _jsx(MZ, {}), MM: _jsx(MM, {}),
    NA: _jsx(NA, {}), NR: _jsx(NR, {}), NP: _jsx(NP, {}), NZ: _jsx(NZ, {}), NI: _jsx(NI, {}),
    NE: _jsx(NE, {}), NG: _jsx(NG, {}), NU: _jsx(NU, {}), KP: _jsx(KP, {}), MK: _jsx(MK, {}),
    NO: _jsx(NO, {}), UG: _jsx(UG, {}), UA: _jsx(UA, {}), UZ: _jsx(UZ, {}), OM: _jsx(OM, {}),
    TL: _jsx(TL, {}), AT: _jsx(AT, {}), PK: _jsx(PK, {}), PW: _jsx(PW, {}), PS: _jsx(PS, {}),
    PA: _jsx(PA, {}), PG: _jsx(PG, {}), PY: _jsx(PY, {}), PE: _jsx(PE, {}), PL: _jsx(PL, {}),
    PT: _jsx(PT, {}), PR: _jsx(PR, {}), QA: _jsx(QA, {}), RO: _jsx(RO, {}), RU: _jsx(RU, {}),
    RW: _jsx(RW, {}), KN: _jsx(KN, {}), LC: _jsx(LC, {}), VC: _jsx(VC, {}), SB: _jsx(SB, {}),
    WS: _jsx(WS, {}), SM: _jsx(SM, {}), ST: _jsx(ST, {}), SA: _jsx(SA, {}), SN: _jsx(SN, {}),
    RS: _jsx(RS, {}), SC: _jsx(SC, {}), SL: _jsx(SL, {}), SG: _jsx(SG, {}), SX: _jsx(SX, {}),
    SI: _jsx(SI, {}), SK: _jsx(SK, {}), SD: _jsx(SD, {}), SO: _jsx(SO, {}), ZA: _jsx(ZA, {}),
    LK: _jsx(LK, {}), SR: _jsx(SR, {}), SY: _jsx(SY, {}), TJ: _jsx(TJ, {}), TW: _jsx(TW, {}),
    TZ: _jsx(TZ, {}), TH: _jsx(TH, {}), TG: _jsx(TG, {}), TK: _jsx(TK, {}), TO: _jsx(TO, {}),
    TT: _jsx(TT, {}), TD: _jsx(TD, {}), CZ: _jsx(CZ, {}), TN: _jsx(TN, {}), TR: _jsx(TR, {}),
    TM: _jsx(TM, {}), TV: _jsx(TV, {}), US: _jsx(US, {}), UY: _jsx(UY, {}), VU: _jsx(VU, {}),
    VA: _jsx(VA, {}), VE: _jsx(VE, {}), AE: _jsx(AE, {}), VN: _jsx(VN, {}), EH: _jsx(EH, {}),
    ZM: _jsx(ZM, {}), ZW: _jsx(ZW, {}), KR: _jsx(KR, {}), SS: _jsx(SS, {}), SE: _jsx(SE, {}),
    CH: _jsx(CH, {})
};
import { useFormContext } from 'react-hook-form';
import useWidgetStore from '../../store/useWidgetStore';
export default function CountrySelectField(props) {
    const { t } = useI18N();
    const theme = useTheme();
    const { consumer } = useWidgetStore();
    const { getValues, setValue, watch } = useFormContext();
    const [country, setCountry] = useState();
    const [countryOptions, setCountryOptions] = useState([]);
    useEffect(() => {
        var _a, _b, _c;
        let _countries = [];
        (_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.field) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.options) === null || _c === void 0 ? void 0 : _c.forEach((country) => {
            _countries.push({ code: country.id.toLowerCase(), label: country.label, flag: Flags[country.id.toUpperCase()] });
        });
        setCountryOptions(_countries);
        let country = getValues(props.name);
        if (!country) {
            country = consumer.country;
        }
        if (!country) {
            country = 'nl';
        }
        if (country) {
            setCountry(country);
        }
    }, []);
    const handleChange = (event) => {
        setCountry(event.target.value);
        setValue(props.name, event.target.value);
    };
    let label = t(props.field.label, 'register');
    if (props.field.required) {
        label = label.concat(' *');
    }
    return (_jsx(_Fragment, { children: (country || props.field.required) && (_jsxs(FormControl, { fullWidth: true, children: [_jsx(InputLabel, { id: props.name.concat('select-label'), sx: {
                        color: theme.palette.text.primary,
                        transform: "translate(14px, 11px) scale(0.75)",
                        "&.Mui-focused": {
                            color: theme.palette.text.primary
                        }
                    }, children: label }), _jsx(Select, { sx: {
                        my: 1,
                        borderColor: theme.palette.text.secondary,
                        backgroundColor: theme.palette.background.default,
                        "& fieldset": {
                            borderColor: theme.palette.text.secondary
                        },
                        "& .Mui-focused": {
                            borderColor: theme.palette.primary.main,
                            color: `${theme.palette.text.primary} !important`
                        },
                        "& label": {
                            color: theme.palette.text.primary
                        },
                        "& svg": {
                            color: theme.palette.text.secondary
                        },
                        "& .MuiInputBase-formControl": {
                            backgroundColor: theme.palette.background.default,
                        },
                        "& .MuiSelect-select": {
                            padding: "25px 14px 16.5px 14px"
                        },
                        "& .MuiInputLabel-formControl:not(.MuiInputLabel-shrink)": {
                            transform: "translate(14px, 20px) scale(1)" // translate(14px, 16px) scale(1);
                        },
                        "& .MuiInputLabel-shrink": {
                            color: theme.palette.text.primary,
                            transform: "translate(14px, 4px) scale(0.75)" // translate(14px, -9px) scale(0.75);
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                            top: 0,
                            "& legend": {
                                display: 'none'
                            }
                        }
                    }, labelId: props.name.concat('select-label'), id: props.name.concat('select'), value: country, label: label, onChange: handleChange, required: !!props.field.required, renderValue: (value) => {
                        let selected = countryOptions.find((country) => { return country.code === value; });
                        if (selected)
                            return t(selected.label, 'register');
                        return '';
                    }, children: countryOptions.map((country) => {
                        if (country.code === '') {
                            return (_jsx(Divider, {}, 'divider'));
                        }
                        return (_jsxs(MenuItem, { value: country.code, children: [_jsx(Box, { sx: { width: '20px', mr: 2, flexShrink: 0 }, children: country.flag }), _jsx(ListItemText, { primary: t(country.label, 'register') })] }, country.code));
                    }) })] })) }));
}
